// EvidenceIndicator — table cell that shows a Lucide paperclip + the
// number of attached evidence links, or a muted em-dash when there are
// none. Becomes a focusable <button> when a click handler is supplied
// AND there's at least one attachment to open; otherwise stays a
// non-interactive <span>. Never renders the 📎 emoji (brand skill §9.6).

import { Paperclip } from "lucide-react";

export interface EvidenceIndicatorProps {
  count: number;
  onClick?: () => void;
}

export default function EvidenceIndicator({
  count,
  onClick,
}: EvidenceIndicatorProps) {
  if (count === 0) {
    return (
      <span
        data-testid="evidence-indicator"
        className="text-slate-400 dark:text-slate-500"
      >
        —
      </span>
    );
  }

  const body = (
    <>
      <Paperclip aria-hidden="true" className="h-3.5 w-3.5" />
      <span>{count}</span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        data-testid="evidence-indicator"
        onClick={onClick}
        aria-label={`${count} evidence attachment${count === 1 ? "" : "s"}`}
        className="inline-flex items-center gap-1 text-slate-600 hover:text-slate-900 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-1 dark:text-slate-300 dark:hover:text-slate-100"
      >
        {body}
      </button>
    );
  }

  return (
    <span
      data-testid="evidence-indicator"
      className="inline-flex items-center gap-1 text-slate-600 dark:text-slate-300"
    >
      {body}
    </span>
  );
}
